$shm_hitalama_components_fullscreen $mol_scroll
	fqn \
	demo_model $shm_hitalama_components_demo
		definition <= definition $shm_hitalama_map_widget_entity_custom
		kind \default
	sub <= content /$mol_view
